var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"dashboard-data",attrs:{"cols":"12"}},[_c('Stats'),_c('Info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }